import React from 'react';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { NewsCards } from '@domain-group/fe-co-allhomes-article-card';
import { BodySection, LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import { BTR_EDITORIAL_TAG } from './btr-more-config';
import * as styles from './news-section.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var NewsSection = _ref => {
  var _ref$articles = _ref.articles,
    articles = _ref$articles === void 0 ? [] : _ref$articles,
    showCta = _ref.showCta;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  if (articles.length === 0) {
    return ___EmotionJSX(React.Fragment, null);
  }
  return ___EmotionJSX(BodySection, {
    css: styles.newsSection
  }, ___EmotionJSX("h3", {
    css: styles.heading
  }, "Build-to-Rent news & advice"), ___EmotionJSX("p", {
    css: styles.subtitle
  }, "Read our Build-to-Rent articles to learn more about how it works and its advantages."), ___EmotionJSX(NewsCards, {
    articles: articles,
    onClick: () => sendEvent('view-article-click'),
    css: styles.cards
  }), showCta && ___EmotionJSX(LinkButton, {
    href: "/topics/".concat(BTR_EDITORIAL_TAG),
    appearance: "outline"
  }, "View all news"));
};
export { NewsSection };